import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MeuPerfilRoutingModule } from './meu-perfil-routing.module';
import { MeuPerfilComponent } from './meu-perfil.component';
import { CropperDialogComponent } from './cropper-dialog/cropper-dialog.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { LyImageCropperModule } from '@alyle/ui/image-cropper';
import { LySliderModule } from '@alyle/ui/slider';
import { LyButtonModule } from '@alyle/ui/button';
import { LyIconModule } from '@alyle/ui/icon';
import { LyDialogModule } from '@alyle/ui/dialog';


@NgModule({
  declarations: [
    MeuPerfilComponent,
    CropperDialogComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    LyImageCropperModule,
    LySliderModule,
    LyButtonModule,
    LyIconModule,
    LyDialogModule,
    MeuPerfilRoutingModule,
  ],
  entryComponents: [
    CropperDialogComponent
  ],
  exports: [
    CropperDialogComponent
  ]
})
export class MeuPerfilModule { }
